import React, { useMemo } from "react";
import { Tooltip } from "antd";
import { groupReactions } from "../../chatMessageUtils";
import "./MessageReactions.css";

const MessageReactions = ({
  reactions = [],
  currentUserId,
  isOutgoing = false,
  onReact,
  disabled = false,
}) => {
  const groupedReactions = useMemo(
    () => groupReactions(reactions),
    [reactions],
  );

  const hasReactions = groupedReactions.length > 0;

  if (!hasReactions) {
    return null;
  }

  return (
    <div
      className={`message-reactions ${
        isOutgoing ? "message-reactions--outgoing" : "message-reactions--incoming"
      }`}
    >
      {hasReactions
        ? groupedReactions.map(({ reaction, users, namesLabel }) => {
            const isMine = users.some(
              (user) => String(user.userIdentifier) === String(currentUserId),
            );

            return (
              <Tooltip key={reaction} title={namesLabel} placement="top">
                <span
                  className={`message-reactions__chip ${isMine ? "is-mine" : ""} ${
                    disabled ? "is-disabled" : ""
                  }`}
                  onClick={() => {
                    if (!disabled) {
                      onReact?.(reaction);
                    }
                  }}
                  onKeyDown={(event) => {
                    if (disabled) {
                      return;
                    }
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      onReact?.(reaction);
                    }
                  }}
                  role="button"
                  tabIndex={disabled ? -1 : 0}
                  aria-label={`${reaction} from ${namesLabel}`}
                  aria-disabled={disabled}
                >
                  <span className="message-reactions__emoji">{reaction}</span>
                  {users.length > 1 ? (
                    <span className="message-reactions__count">{users.length}</span>
                  ) : null}
                </span>
              </Tooltip>
            );
          })
        : null}
    </div>
  );
};

export default MessageReactions;
